import { useEffect, useRef, useState } from 'react'
import { cn } from '@/lib/utils'
import Constant from '@/utils/Constant'
import { useDebounce } from 'use-debounce'
import { useAuth } from '@/Context/AuthContext'

const SearchableDropdownWithOptions = ({ options = [], label, selectedVal, handleChange, placeholder, field, disabled = false, className = '' }) => {
    const { userInfo } = useAuth()
    const [query, setQuery] = useState('')
    const [isOpen, setIsOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [filterData, setFilterData] = useState([])
    const [searchableQuery] = useDebounce(query, Constant.DEBOUNCE_DELAY)
    const [selectedIndex, setSelectedIndex] = useState(-1)
    const [keyDirection, setKeyDirection] = useState(-1)
    const optionRefs = useRef([])
    const optionsContainerRef = useRef(null)
    const inputRef = useRef(null)

    useEffect(() => {
        optionRefs.current = optionRefs.current.slice(0, filterData.length)
    }, [filterData])
    useEffect(() => {
        setFilterData(options)
    }, [options])

    const handleKeyDown = (event) => {
        if (!isOpen) {
            setIsOpen(event && event.target === inputRef.current)
        }
        const selectedOptionRef = optionRefs.current.length > 0 && optionRefs.current[selectedIndex]
        const optionsContainerRef2 = optionsContainerRef.current

        if (event.key === 'ArrowDown') {
            event.preventDefault()
            if (keyDirection !== -1) {
                setKeyDirection(-1)
            }
            setSelectedIndex((prevIndex) => {
                const next = Math.min(prevIndex + 1, filterData.length - 1)
                return next
            })
        } else if (event.key === 'ArrowUp') {
            event.preventDefault()
            if (keyDirection !== 1) {
                setKeyDirection(1)
            }
            setSelectedIndex((prevIndex) => {
                const next = Math.max(prevIndex - 1, 0)
                return next
            })
        } else if (event.key === 'Enter') {
            event.preventDefault()
            console.log('teee')
            if (selectedIndex >= 0 && filterData[selectedIndex]) {
                selectOption(filterData[selectedIndex])
                setIsOpen(false)
            }
        } else if (event.key === 'Tab') {
            if (!isOpen) {
                setIsOpen(true)
            }
        }
        if (selectedOptionRef && optionsContainerRef2) {
            selectedOptionRef.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            })
        }
    }

    useEffect(() => {
        document.addEventListener('click', toggle)
        return () => document.removeEventListener('click', toggle)
    }, [])

    function toggle(e) {
        setIsOpen(e && e.target === inputRef.current)
    }

    const handleFocus = () => {
        if (!isOpen) {
            setIsOpen(true)
        } // Open the dropdown when the input gets focus
    }
    const handleBlur = () => {
        setTimeout(() => {
            setIsOpen(false)
        }, 200)
    }

    useEffect(() => {
        document.addEventListener('click', toggle)
        return () => document.removeEventListener('click', toggle)
    }, [])

    const selectOption = (option) => {
        setQuery(() => '')
        handleChange(option[label])
        setIsOpen((isOpen) => !isOpen)
    }

    function toggle(e) {
        setIsOpen(e && e.target === inputRef.current)
    }

    const getDisplayValue = () => {
        if (query) return query
        if (selectedVal) return selectedVal

        return ''
    }

    const filter = (options) => {
        return options?.filter((option) => option[label]?.toLowerCase().indexOf(query.toLowerCase()) > -1)
    }

    return (
        <div className="dropdownx">
            <div className="control">
                <div className="selected-value">
                    <input
                        ref={inputRef}
                        type="text"
                        {...field}
                        value={getDisplayValue()}
                        name="searchTerm"
                        onChange={(e) => {
                            setQuery(e.target.value)
                            handleChange('')
                            setIsOpen(false)
                        }}
                        onKeyDown={handleKeyDown}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        placeholder={placeholder}
                        onClick={toggle}
                        className={cn(
                            `flex w-full rounded-md bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-neutral-950 placeholder:text-neutral-500 focus-visible:outline-none focus-visible:ring-1  disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-neutral-800 dark:file:text-neutral-50 dark:placeholder:text-neutral-400 dark:focus-visible:ring-neutral-300 border shadow-sm text-[13px] input-outline-shadow ${className}`
                        )}
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className={`options bg-white shadow-md border rounded-md ${isOpen ? 'open' : ''}`} ref={optionsContainerRef}>
                {options.length > 0 ? (
                    filter(options).map((option, index) => {
                        return (
                            <div
                                ref={(el) => (optionRefs.current[index + keyDirection] = el)} // Add ref to each option
                                onClick={() => selectOption(option)}
                                className={cn(
                                    'px-4 py-2 cursor-pointer hover:bg-blue-100 text-[13px]',
                                    option[label] === selectedVal && 'bg-blue-200 font-semibold',
                                    index === selectedIndex && 'bg-blue-100'
                                )}
                                key={`${index}`}
                            >
                                {option[label]}
                            </div>
                        )
                    })
                ) : (
                    <div className="px-4 py-2 text-center text-gray-500 text-[13px]">No data found</div>
                )}
            </div>
        </div>
    )
}

export default SearchableDropdownWithOptions
